import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import {
    handleAccountStatus,
    handleVerificationStep,
    resetVerification,
} from "../../redux/action/verificationAction";
import IDWiseKYC from "../common/IDWiseKYC";
import {
    getVerificationStatus,
    setVerificationFlag,
} from "../../redux/action/authAction";
import { useNavigate } from "react-router-dom";
import { VERIFICATION_STATUS } from "../../helpers";
import { sendNotification } from "../notifications/NotificationService";
import useTranslationHook from "../hooks/useTranslationHook";
import Button from "../common/Button";
import { getSecretByName } from "../../redux/action/keyVaultAction";
import { handleVerificationDocument } from "../../redux/action/verificationAction";
import { Fragment, useRef } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

const UAE_FLOW_ID = process.env.REACT_APP_IS_AZURE_VAULT
    ? process.env.REACT_APP_IDWISE_UAE_FLOW_ID
    : await dispatch(
        getSecretByName(
            "REACT_APP_IDWISE_UAE_FLOW_ID"
        )
    )
const PASSPORT_FLOW_ID = process.env.REACT_APP_IS_AZURE_VAULT
    ? process.env.REACT_APP_IDWISE_PASSPORT_FLOW_ID
    : await dispatch(
        getSecretByName(
            "REACT_APP_IDWISE_PASSPORT_FLOW_ID"
        )
    )

const uploadSchema = [
    {
        name: "upload_Broker_License",
        label: "Upload Broker License",
        heading: "Broker License",
        apiKey: "broker_licence",
        errMsg: "Broker License is required",
    },
    {
        name: "upload_Front_EID",
        label: "Upload Front Emirates ID",
        heading: "Front Emirates ID",
        apiKey: "front_eid",
        errMsg: "Front Emirates ID is required",
    },
    {
        name: "upload_Back_EID",
        label: "Upload Back Emirates ID",
        heading: "Back Emirates ID",
        apiKey: "back_eid",
        errMsg: "Back Emirates ID is required",
    },
];

const BrokerManualUpload = ({ user, onSuccess }) => {
    const dispatch = useDispatch();
    const { t } = useTranslationHook();

    const fileInputRefs = useRef({});
    const [files, setFiles] = useState({});
    const [fileNames, setFileNames] = useState({});
    const [error, setError] = useState(false);
    const [filePreviews, setFilePreviews] = useState({});

    const handleFile = (file, name) => {
        setFiles((p) => ({ ...p, [name]: file }));
        setFileNames((p) => ({ ...p, [name]: file.name }));
        setFilePreviews((p) => ({ ...p, [name]: URL.createObjectURL(file) }));
        setError(false);
    };

    const handleDelete = (name) => {
        if (filePreviews[name]) URL.revokeObjectURL(filePreviews[name]);

        setFiles((p) => {
            const c = { ...p };
            delete c[name];
            return c;
        });
        setFileNames((p) => {
            const c = { ...p };
            delete c[name];
            return c;
        });
        setFilePreviews((p) => {
            const c = { ...p };
            delete c[name];
            return c;
        });

        if (fileInputRefs.current[name]) {
            fileInputRefs.current[name].value = "";
        }
    };

    const submit = async () => {
        const allUploaded = uploadSchema.every((i) => files[i.name]);

        if (!allUploaded) {
            setError(true);
            return;
        }

        const fd = new FormData();
        fd.append("user", user.user_id);
        fd.append("site_id", user.site_id);
        fd.append("verification_type", 3);

        uploadSchema.forEach((i) => {
            fd.append(i.apiKey, files[i.name]);
        });

        const res = await dispatch(handleVerificationDocument(fd));

        if (res?.status === 200 && res?.data?.error === 0) {
            onSuccess();
        }
    };
    return (
        <>
            <div className="bdr-list">
                {uploadSchema.map((ele, index) => (
                    <Fragment key={ele.name}>
                        <ul className="doc-list">
                            <li>
                                <div className="item">
                                    <div className="block">
                                        <div className="icon">
                                            <img
                                                src="/img/documents-icon.svg"
                                                alt="Upload Icon"
                                            />
                                        </div>
                                        <h6>
                                            {t(ele.heading)} *
                                            {error && !fileNames[ele.name] && (
                                                <span className="text-danger">
                                                    {t(ele.errMsg)}
                                                </span>
                                            )}
                                        </h6>
                                    </div>
                                    <div className="block">
                                        <div className="doc-upload">
                                            <button
                                                className="btn btn-white btn-sm"
                                                disabled={fileNames[ele.name]}
                                            >
                                                {t("Upload")}
                                                <img
                                                    src={"/img/upload-icon.svg"}
                                                    alt="Upload Icon"
                                                    class="ml4"
                                                />
                                            </button>
                                            <input
                                                type="file"
                                                name="myfile"
                                                accept=".pdf,.doc,.docx,image/*"
                                                onChange={(e) => {
                                                    const file = e.target.files[0];
                                                    if (!file) return;

                                                    const isImage =
                                                        file.type.startsWith(
                                                            "image/"
                                                        );
                                                    const isPdf =
                                                        file.type ===
                                                        "application/pdf";

                                                    if (!isImage && !isPdf) {
                                                        toast.info(
                                                            t("Only Image or PDF files are allowed."),
                                                            {
                                                                toastId: ele.name,
                                                            }
                                                        );

                                                        e.target.value = ""; // reset input
                                                        return;
                                                    }
                                                    handleFile(file, ele.name);
                                                }}
                                                disabled={fileNames[ele.name]}
                                                ref={(el) =>
                                                (fileInputRefs.current[
                                                    ele.name
                                                ] = el)
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                                {fileNames[ele.name] && (
                                    <ol className="pdf-list">
                                        <li>
                                            <div className="icon">
                                                <img
                                                    src={`/img/${fileNames[ele.name].includes("pdf") ? "doc-icon.svg" : "image-iconB.svg"}`}
                                                    alt=""
                                                />
                                            </div>
                                            <h6>
                                                <a
                                                    href={filePreviews[ele.name]}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {fileNames[ele.name]}
                                                </a>
                                            </h6>
                                            <button class="delete-icon">
                                                <img
                                                    src="/img/delete-icon.svg"
                                                    alt="Delete Icon"
                                                    onClick={() =>
                                                        handleDelete(ele.name)
                                                    }
                                                />
                                            </button>
                                        </li>
                                    </ol>
                                )}
                            </li>
                        </ul>
                    </Fragment>
                ))}
            </div>
            <div className="clearfix">
                <button
                    className="btn btn-primary btn-lg btn-full"
                    onClick={submit}
                >
                    {t("Next")}
                </button>
            </div>
        </>
    );
};


const BrokerHybridKYC = ({ user, flowId, onFinished }) => {
    const [phase, setPhase] = useState(
        "broker_doc_uploaded" in user && user?.broker_doc_uploaded
            ? "kyc"
            : "upload"
    );

    return (
        <>
            {phase === "upload" && (
                <BrokerManualUpload
                    user={user}
                    onSuccess={() => setPhase("kyc")}
                />
            )}

            {phase === "kyc" && (
                <IDWiseKYC
                    flowId={flowId}
                    user={user}
                    onFinished={onFinished}
                />
            )}
        </>
    );
};

const VerifyAccStep = () => {
    const { t } = useTranslationHook();
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const user = useSelector((state) => state.auth.user);
    const verification_step = useSelector(
        (state) => state.verification.verification_step
    );

    const [flowId, setFlowId] = useState(null);

    // Broker always UAE → skip Step-2
    useEffect(() => {
        if (user?.account_type === 2) {
            setFlowId(UAE_FLOW_ID);
            dispatch(handleVerificationStep(3));
        }
    }, [user?.account_type]);

    const onSubmit = (data) => {
        if (verification_step === 2) {
            const isUAE = data.uae_resident === "yes";
            setFlowId(isUAE ? UAE_FLOW_ID : PASSPORT_FLOW_ID);
            dispatch(handleVerificationStep(3));
        }
    };

    const handleFinishedVerification = async (journeyId) => {
        const res = await dispatch(
            getVerificationStatus(
                journeyId,
                user?.id || user?.user_id,
                flowId === UAE_FLOW_ID ? 1 : 2
            )
        );

        if (res.error === 0) {
            const label = `${res?.data?.kyc_decision || ""}`.toLowerCase();
            dispatch(handleAccountStatus(VERIFICATION_STATUS[label]));
            window.location.reload();
        }
    };

    const renderProgress = (step) => {
        switch (step) {
            case 2:
                return (
                    <>
                        <li className="active"></li>
                        <li></li>
                        <li></li>
                    </>
                );
            case 3:
                return (
                    <>
                        <li className="full"></li>
                        <li className="active"></li>
                        <li></li>
                    </>
                );
            case 4:
                return (
                    <>
                        <li className="full"></li>
                        <li className="full"></li>
                        <li className="active"></li>
                    </>
                );
            default:
                return null;
        }
    };

    return (
        <div className="body-content-short">
            <section className="verify-process-wrap ds">
                <div className="container py-5">
                    <div className="row justify-content-md-center">
                        <div
                            className={`${
                                verification_step === 3
                                    ? "col-lg-10 col-xl-8"
                                    : "col-lg-6"
                            } wow fadeInUp`}
                            data-wow-delay="0.5s"
                        >
                            <div
                                className={`verify-box${
                                    verification_step === 3
                                        ? " verify-box-kyc"
                                        : ""
                                }`}
                            >
                                <h5>
                                    {t("Complete Your Profile")}
                                    <span>
                                        {t(
                                            "Upload the documents below"
                                        )}
                                    </span>
                                </h5>

                                <ul className="verify-progress">
                                    {renderProgress(verification_step)}
                                </ul>

                                {/* STEP-2 — DO NOT CHANGE UI */}
                                {verification_step === 2 &&
                                    user?.account_type !== 2 && (
                                        <form
                                            onSubmit={handleSubmit(onSubmit)}
                                            autoComplete="off"
                                        >
                                            <h6>{t("Are you a UAE resident?")}</h6>

                                            <ul className="verify-list mb-5">
                                                <li>
                                                    <input
                                                        className="css-radio"
                                                        type="radio"
                                                        value="yes"
                                                        id="1"
                                                        {...register(
                                                            "uae_resident",
                                                            {
                                                                required: t(
                                                                    "This field is required"
                                                                ),
                                                            }
                                                        )}
                                                    />
                                                    <label
                                                        htmlFor="1"
                                                        className="css-labell"
                                                    >
                                                        {t(
                                                            "Yes, I have Emirates ID"
                                                        )}
                                                    </label>
                                                </li>

                                                <li className="veri-error">
                                                    {errors.uae_resident && (
                                                        <div className="required font14">
                                                            {t(
                                                                errors.uae_resident
                                                                    .message
                                                            )}
                                                        </div>
                                                    )}
                                                </li>
                                            </ul>

                                            <div className="row">
                                                <div className="col-md-6">
                                                    <Button
                                                        className="btn btn-sky btn-lg"
                                                        type="button"
                                                        onClick={() =>
                                                            dispatch(
                                                                handleVerificationStep(
                                                                    1
                                                                )
                                                            )
                                                        }
                                                        label={t("Back")}
                                                        backIconClassName="fa-solid fa-angle-left mr4"
                                                    />
                                                </div>

                                                <div className="col-md-6 right">
                                                    <Button
                                                        className="btn btn-primary btn-lg"
                                                        type="submit"
                                                        label={t("Next")}
                                                        nextIconClassName="fa-solid fa-angle-right ml4"
                                                    />
                                                </div>
                                            </div>
                                        </form>
                                    )}

                                {/* STEP-3 */}
                                {verification_step === 3 &&
                                    (user?.account_type === 2 ? (
                                        <BrokerHybridKYC
                                            user={user}
                                            flowId={UAE_FLOW_ID}
                                            onFinished={handleFinishedVerification}
                                        />
                                    ) : (
                                        <IDWiseKYC
                                            flowId={flowId}
                                            user={user}
                                            onFinished={handleFinishedVerification}
                                            onCancelled={() => {
                                                dispatch(resetVerification());
                                                navigate("/");
                                            }}
                                            onStarted={(user_id) => {
                                                dispatch(
                                                    setVerificationFlag(user_id)
                                                );
                                            }}
                                        />
                                    ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default VerifyAccStep;
